import { render, staticRenderFns } from "./outadd.vue?vue&type=template&id=6c52b1e2"
import script from "./outadd.vue?vue&type=script&lang=js"
export * from "./outadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports